<template>
    <div class="reports">
        <Header :app="app" :left="true" :right="true" title="Reports">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.push('/')">
                    &laquo;
                </a>
            </template>

            <template v-slot:right>
                <a v-on:click="app.downloadTable(filename, tableData)" href="javascript:;">
                    <font-awesome-icon icon="download" />
                </a>
            </template>
        </Header>

        <div class="content">
            <div class="header">
                <div class="columns">
                    <div class="column third-column">
                        <input type="date" v-model="startAt">
                    </div>
                    <div class="column third-column desktop-only">
                        <p>to</p>
                    </div>
                    <div class="column third-column">
                        <input type="date" v-model="endAt">
                    </div>
                </div>
                <select v-model="selectedLocation">
                    <option value="">All Locations</option>
                    <option v-for="location in app.sortedLocations" :key="location.id" :value="location">
                        {{location.name}}
                    </option>
                </select>
            </div>

            <div class="columns">
                <div class="column half-column">
                    <div class="graph number-graph">
                        <h1>{{report.uniquePeople}}</h1>
                        <p>Unique Attendees</p>
                    </div>
                </div>
                <div class="column half-column">
                    <div class="graph number-graph">
                        <h1>{{report.totalPresents}}</h1>
                        <p>Total Presents</p>
                    </div>
                </div>
            </div>

            <Table :data="tableData" :pretty="!!selectedLocation" />

            <form>
                <div class="field">
                    <br>
                    <label v-if="!!selectedLocation">
                        <input type="checkbox" :checked="hideEmpties" v-on:change="hideEmpties = !hideEmpties">
                        Hide Absentees
                    </label>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';
import Table  from '@/components/table/component.vue';

export default {
    name: 'reports',
    components: {
        Header,
        Table
    },
    props: ['app'],
    data() {
        var _ = this,
            startAt = new Date(),
            endAt = new Date();

        startAt.setDate(startAt.getDate() - 15);

        return {
            selectedLocation: '',
            hideEmpties: true,
            startAt: startAt.getFullYear() + '-' + _.app.zeroPad(startAt.getMonth() + 1) + '-' + _.app.zeroPad(startAt.getDate()),
            endAt: endAt.getFullYear() + '-' + _.app.zeroPad(endAt.getMonth() + 1) + '-' + _.app.zeroPad(endAt.getDate()),
        };
    },
    computed: {
        selectedLocations() {
            return this.app.sortedLocations;
        },

        filename() {
            var _ = this;
            return (_.selectedLocation ? _.selectedLocation.name : 'All Locations') + ' (' + _.startAt + ' to ' + _.endAt + ').csv';
        },

        report() {
            var _ = this,
                startAt = _.app.parseYMD( _.startAt ),
                endAt = _.app.parseYMD( _.endAt );

            if (_.selectedLocation) {
                return _.app.buildCollectionReport(_.app.sortedPeople, startAt, endAt, function(days, item) {
                    var day = days.find(function(day) {
                        return day.locationId === _.selectedLocation.id && day.peopleIds && day.peopleIds.indexOf(item.id) !== -1;
                    });

                    return {
                        uniqueIds: day ? day.peopleIds : undefined,
                        count: day ? 1 : 0
                    };
                });
            } else {
                return _.app.buildCollectionReport(_.selectedLocations, startAt, endAt, function(days, item) {
                    var day = days.find(function(day) {
                        return day.locationId === item.id;
                    });

                    return {
                        uniqueIds: day ? day.peopleIds : undefined,
                        count: day ? day.peopleIds.length : 0
                    };
                });
            }
        },

        tableData() {
            var _ = this;

            if (_.selectedLocation) {
                return _.app.reportTableData(_.app.sortedPeople, _.report.dates, 'Person', function(item) {
                    return _.app.personName(item);
                }, _.hideEmpties);
            } else {
                return _.app.reportTableData(_.selectedLocations, _.report.dates, 'Location');
            }
        }
    }
};
</script>
